import {css} from '@emotion/css';
import {containerStackMobile} from '../../../styles/js/mixins/layout';

const styles = {
  businessStats: css`
    label: businessStats;
    ${containerStackMobile}
  `,
};

export default styles;
